import { css } from '@emotion/react';
import { t } from 'i18n';
import Skeleton from 'react-loading-skeleton';

import { Divider } from '../../../Divider';
import { theme } from '../../../theme';

import { styles } from './styles';

const container = css`
  margin-top: ${theme.spacing.sm};
`;
const container2 = css`
  margin-top: ${theme.spacing.md};
`;

export const FlightInfoSkeleton = () => {
  return (
    <div css={styles.flightDetailsWrapper}>
      <h3>{t('newBooking')}</h3>
      <>
        <Skeleton width={100} />
        <Skeleton width={'80%'} />
        <div css={container}>
          <Skeleton width={75} />
          <Skeleton width={100} />
          <Skeleton width={100} />
        </div>
        <Divider css={styles.divider} />
      </>
      <div css={container}>
        <Skeleton width={100} />
        <Skeleton width={'80%'} />
        <div css={container}>
          <Skeleton width={75} />
          <Skeleton width={100} />
          <Skeleton width={100} />
        </div>
        <Divider css={styles.divider} />
      </div>
      <div css={container2}>
        <h4>{t('common:travelers')}</h4>
        <Skeleton width={200} />
        <Skeleton width={200} />
      </div>
    </div>
  );
};
